export default function Divider({ text }) {
  return (
    <div className="flex h-10 w-full items-center justify-center gap-2.5">
      <span className="h-px flex-1 bg-zi-buttonbg-primary opacity-50"></span>
      <p className="shrink-0 text-xs text-zi-blue-light dark:text-zi-text-dark">
        {text}
      </p>
      <span className="h-px flex-1 bg-zi-buttonbg-primary opacity-50"></span>
    </div>
  );
}
